const isBuilding = process.env.NEXT_PHASE === "phase-production-build"
export const isDev = process.env.NEXT_PUBLIC_VERCEL_ENV === "development"
const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview"

function getAbsoluteAPI() {
  // If we're building, we need to handle this differently, since we can't rely on
  // NextJS middleware / rewrites to rewrite /api to the API.
  //
  // So, we need to specify the full URL.
  if (isBuilding) {
    return "https://api.paragraph.com"
  }

  // If we're forcing the domain, use that.
  if (process.env.NEXT_PUBLIC_FORCE_DOMAIN) {
    return process.env.NEXT_PUBLIC_FORCE_DOMAIN + "/api"
  }

  // If we're in dev, just use localhost.
  if (isDev) {
    return "http://localhost:8080"
  }

  // Otherwise, we're not building and we're in preview on Vercel.
  if (isPreview) {
    return "https://" + process.env.NEXT_PUBLIC_VERCEL_URL + "/api"
  }

  // Now, we're on production. If we're NOT on paragraph.com,
  // we're on a custom domain, so use that domain for the API..
  if (
    typeof window !== "undefined" &&
    window.location.hostname !== "paragraph.com"
  ) {
    return `https://${window.location.hostname}/api`
  }

  // If we're on production, use api.paragraph.com.
  //
  // We do NOT want to use paragraph.com/api, since that would
  // cause a massive amount of needless edge middleware requests
  // to occur.
  return "https://api.paragraph.com"
}

// This is the URL of the API server corresponding to this deploy.
// This is also used in next.config.js
export const absoluteAPI = getAbsoluteAPI()

/**
 * Helper constant that should be used for ALL base URLs on Paragraph.
 *
 * This properly sets the URL based on environment.
 *
 */
export const host =
  // In production
  isProduction
    ? "https://paragraph.com"
    : // Testing locally
      process.env.NEXT_PUBLIC_FORCE_DOMAIN
      ? process.env.NEXT_PUBLIC_FORCE_DOMAIN
      : process.env.NEXT_PUBLIC_VERCEL_URL
        ? // On preview branch OR generally deployed on vercel
          `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
        : "http://localhost:3001"
